import request from 'axios';
import { eagleCPCFlow, getCookie, getSession, whwTech } from '../components/common/Helpers';
// import inspecioResponse from './../../json/D2D/inspecioResponse';
import { getChannelId } from '../services/HttpService';

const axios = require('axios').default;

request.interceptors.request.use(
  (config) => {
    const requestConfig = config;
    if (window.document && window.document.referrer) {
      requestConfig.headers['from-referrer'] = window.document.referrer;
      requestConfig.headers.fromReferrer = window.document.referrer;
    }
    requestConfig.headers.channelId = getChannelId();
    requestConfig.headers.common['p-csrf-token'] = getCookie('p_csrftkn') || null;
    return requestConfig;
  },
  (error) => Promise.reject(error),
);

const postAPI = (url, data) => axios.request({ method: 'post', url, data });

// const getAPI = (url) => axios.request({ method: 'get', url });

// export const callLongPollingApi = (url, dispatch) => {
//     const processApi = window.setInterval(() => {
//         fetchApi(url, processApi, dispatch);
//     }, 5000);
// }

// const fetchApi = (url, processApi, dispatch) => {
export const callLongPollingApi = (url, data, dispatch) => {
  postAPI(url, data)
    .then((response) => {
      if (response.data.status === 'Success' && response.data.payload) {
        let responseArray = '';

        // In case of eid, the value is an object, spilt cannot work on object - So, added check below.
        if (typeof response.data.payload.value !== 'object' && response.data.payload.value) {
          responseArray = response.data.payload.value && response.data.payload.value.split(' ');
        }
        switch (response.data.payload.field) {
          case 'pin': {
            // const pinRes = response.data.payload.value.split(' ');
            let pinValue = '';
            if (response.data.event === 'verifyPin') {
              pinValue = {
                passCode: responseArray[0] ? responseArray[0] : '',
                keyid: responseArray[1] ? responseArray[1] : '',
                phaseBit: responseArray[2] ? responseArray[2] : '',
              };
              if (eagleCPCFlow() === 'true') {
                dispatch({ type: 'CPC_INSP_VERIFY_PIN', response: pinValue });
                const eagleCpcPin = pinValue.passCode === '';
                if (eagleCpcPin) {
                  callLongPollingApi(url, data, dispatch);
                }
              }
              if (whwTech()=== 'true') {
                dispatch({ type: 'WHW_INSP_VERIFY_PIN', response: pinValue });
                const whwTechPin = pinValue.passCode === '';
                if (whwTechPin) {
                  callLongPollingApi(url, data, dispatch);
                }
              }
              dispatch({ type: 'FETCH_TECH_CBAND_PIN', response: pinValue });
              const isCBandPin = pinValue.passCode === '';
              // eslint-disable-next-line no-unused-expressions
              isCBandPin && callLongPollingApi(url, data, dispatch);
            }

            // if (response.data.event === 'creditHold') {
            //   // debugger;
            //   const creditValue = response.data.payload && response.data.payload.action
            //   dispatch({ type: 'FETCH_TECH_CBAND_CREDIT_HOLD', response: creditValue });
            //   callLongPollingApi(url, data, dispatch);
            // }

            if (response.data.event === 'creditAppData') {
              pinValue = {
                pin: responseArray[0] ? responseArray[0] : '',
              };
              dispatch({ type: 'FETCH_LOGIN_PIN', response: pinValue });
              callLongPollingApi(url, data, dispatch);
            } else {
              pinValue = {
                passCode: responseArray[0] ? responseArray[0] : '',
                keyid: responseArray[1] ? responseArray[1] : '',
                phaseBit: responseArray[2] ? responseArray[2] : '',
              };
              dispatch({ type: 'FETCH_LOGIN_PIN', response: pinValue });
            }
            break;
          }
          case 'SSN': {
            // const ssnRes = response.data.payload.value.split(' ');
            const ssnValue = {
              SSN: responseArray[0] ? responseArray[0] : '',
              originalSSN: response.data.payload.value ? response.data.payload.value : '',
            };
            dispatch({ type: 'FETCH_SSN', response: ssnValue });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'confirmSSN': {
            // const confSSNRes = response.data.payload.value.split(' ');
            const confSSNValue = {
              ConfSSN: responseArray[0] ? responseArray[0] : '',
            };
            dispatch({ type: 'FETCH_CONF_SSN', response: confSSNValue });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'pinConf': {
            // const pinConfRes = response.data.payload.value.split(' ');
            const pinConfValue = {
              pinConf: responseArray[0] ? responseArray[0] : '',
              originalPinConf: response.data.payload.value ? response.data.payload.value : '',
            };
            dispatch({ type: 'FETCH_CONF_PIN', response: pinConfValue });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'dateOfBirth': {
            // const dobRes = response.data.payload.value.split(' ');
            const dobValue = {
              dateOfBirth: responseArray[0] ? responseArray[0] : '',
            };
            dispatch({ type: 'FETCH_DATEOFBIRTH', response: dobValue });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'number': {
            // const cardNumberRes = response.data.payload.value.split(' ');
            const cardNumberValue = {
              cardNumber: responseArray[0] ? responseArray[0] : '',
              originalCardValue: response.data.payload.value,
            };
            dispatch({ type: 'FETCH_CARD_NUMBER', response: cardNumberValue });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'expiration': {
            // const expirationRes = response.data.payload.value.split(' ');
            const expiration = responseArray[0] ? responseArray[0] : '';
            dispatch({ type: 'FETCH_CARD_EXPIRATION', response: expiration });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'cvv': {
            // const cvvRes = response.data.payload.value.split(' ');
            const cvv = responseArray[0] ? responseArray[0] : '';
            dispatch({ type: 'FETCH_CARD_CVV', response: cvv });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'zipCode': {
            // const zipCodeRes = response.data.payload.value.split(' ');
            const zipCode = responseArray[0] ? responseArray[0] : '';
            dispatch({ type: 'FETCH_ZIPCODE', response: zipCode });
            callLongPollingApi(url, data, dispatch);
            break;
          }
          case 'ipAddress': {
            setTimeout(() => {
              callLongPollingApi(url, data, dispatch);
            }, 5000);
            break;
          }
          case 'eid': {
            dispatch({ type: 'D2D_EID_QUESTION_ANS', response: response.data.payload.value });
            // setTimeout(() => {
            //   callLongPollingApi(url, data, dispatch);
            // }, 5000);
            break;
          }
          case 'email': {
            if (eagleCPCFlow() === 'true') {
              dispatch({ type: 'CPC_VERIFY_EMAIL', response: response.data.payload.value });
              break;
            }
            if (whwTech() === 'true') {
              dispatch({ type: 'WHW_VERIFY_EMAIL', response: response.data.payload.value });
              break;
            }
            dispatch({ type: 'TECH_CBD_VERIFY_EMAIL', response: response.data.payload.value });
            break;
          }
          case 'authCode': {
            if (eagleCPCFlow() === 'true') {
              dispatch({ type: 'CPC_VERIFY_EMAIL_AUTH_CODE', response: response.data.payload.value });
              break;
            }
            if (whwTech() === 'true') {
              dispatch({ type: 'WHW_VERIFY_EMAIL_AUTH_CODE', response: response.data.payload.value });
              break;
            }
            dispatch({ type: 'TECH_CBD_VERIFY_AUTH_CODE', response: response.data.payload.value });
            break;
          }
          default:
            break;
        }
        if (response.data.event === 'creditCardData' && response.data.payload.action === 'enableSubmit') {
          dispatch({ type: 'ENABLE_PAYMENT_SUBMIT', response: true });
          dispatch({ type: 'CALL_3D_API', response: response.data.payload });
          setTimeout(() => {
            callLongPollingApi(url, data, dispatch);
          }, 30000);
        } else if (response.data.event === 'submitSignature' && response.data.payload.tacsignature !== '') {
          dispatch({ type: 'ENABLE_TERMS_AND_CONDITION_SUBMIT', response: true });
          dispatch({ type: 'UPDATE_TOS_SIGNATURE', response: response.data.payload.tacsignature });
          dispatch({ type: 'UPDATE_TECH_TOS_SIGNATURE', response: response.data.payload.tacsignature });
          const setCallLong = setTimeout(() => {
            callLongPollingApi(url, data, dispatch);
          }, 30000);
          clearTimeout(setCallLong);
          // setTimeout(() => {
          //   callLongPollingApi(url, data, dispatch);
          // }, 30000);
        } else if (response.data.event === 'verifyPin' && response.data.payload.value !== '') {
          // dispatch({ type: 'ENABLE_TERMS_AND_CONDITION_SUBMIT', response: true });
          dispatch({ type: 'VERIFIED_PIN_CBAND', response: response.data.payload.value });
          const setCallLong = setTimeout(() => {
            callLongPollingApi(url, data, dispatch);
          }, 20000);
          clearTimeout(setCallLong);
        } else if (response.data.event === 'declineTandC' && response.data.payload && response.data.payload.pageName === 'tandc') {
          dispatch({ type: 'TECH_CBD_TERMS_AND_CONDITION_DECLINED', response: true });
        } else if (
          response.data.event === 'creditHold' &&
          response.data.payload &&
          response.data.payload.action &&
          response.data.payload.action === 'creditHoldSubmitted'
        ) {
          const creditValue = response.data.payload && response.data.payload.action;
          dispatch({ type: 'FETCH_TECH_CBAND_CREDIT_HOLD', response: creditValue });
        } else if (response.data.event === 'acceptPlanUpdate' && response.data.payload && response.data.payload.pageName === 'fivegCPC') {
          dispatch({ type: 'CPC_ACCEPT_PLANS', response: response.data.payload });
        } else if (response.data.event === 'declinePlanUpdate' && response.data.payload && response.data.payload.pageName === 'fivegCPC') {
          dispatch({ type: 'CPC_DECLINE_PLANS_UPDATE', response: response.data.payload });
        } else if (response.data.event === 'whwTncAccepted' && response.data.payload && response.data.payload.pageName === 'whwTnc') {
          dispatch({ type: 'WHW_ACCEPT_PLANS', response: response.data.payload });
        } else if (response.data.event === 'whwTncDeclined' && response.data.payload && response.data.payload.pageName === 'whwTnc') {
          dispatch({ type: 'WHW_DECLINE_PLANS_UPDATE', response: response.data.payload });
        }
      } else if ((getCookie('cbandToken') !== '' || eagleCPCFlow() === 'true' || whwTech() === 'true') && getSession('isSubmitted') !== 'Y') {
        setTimeout(() => {
          callLongPollingApi(url, data, dispatch);
        }, 20000);
      } else {
        const isSubmitted = getSession('isSubmitted');
        const isTOSAPISuccess = getSession('isTOSAPISuccess');
        const setCallLong = setTimeout(() => {
          callLongPollingApi(url, data, dispatch);
        }, 20000);
        if (isSubmitted === 'Y' || isTOSAPISuccess === 'Y') {
          clearTimeout(setCallLong);
        }
      }
    })
    .catch((error) => {
      console.log(error);
      // eslint-disable-next-line no-console
      const isSubmitted = getSession('isSubmitted');
      const setCallLong = setTimeout(() => {
        callLongPollingApi(url, data, dispatch);
      }, 30000);
      if (isSubmitted === 'Y') {
        clearTimeout(setCallLong);
      }
      // dispatch(asyncFetchFailed());// on API failure
      // dispatch(hideNotification());
    });
};
